/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Zprava doleva",
		"timeZoneID": "Časové pásmo",
		"skin": "Styl",
		"metricsFileImportTask": "Nový import ze souborů",
		"displayMode": "Výchozí zobrazení",
		"credentialRenewed": "Vaše přihlašovací údaje byly obnoveny s aktuálním ID uživatele a heslem.",
		"productLocale": "Jazyk produktu",
		"toggleDisabled": "vypnuto",
		"credentialChange": "Obnovit",
		"log_level_Debug": "Ladění",
		"confirmNewPassword": "Potvrdit nové heslo",
		"unsavedViewMsg2": "Vaše změny budou ztraceny, pokud je nejprve neuložíte.",
		"supportPortalErrorMessage": "Zkuste to znovu. Pokud problém přetrvává, obraťte se na administrátora.",
		"legalText": "Licencované materiály - vlastnictví IBM Corp. © Copyright IBM Corporation a další 2005, %{year}. IBM, logo IBM, ibm.com a Cognos jsou ochranné známky nebo registrované ochranné známky společnosti International Business Machines Corp. registrované v mnoha jurisdikcích na celém světě. Aktuální seznam ochranných známek IBM je k dispozici na webu www.ibm.com/legal/copytrade.shtml. Licence k tomuto programu je poskytována za licenčních podmínek dodávaných s programem. Licenční smlouva může být buď umístěna v adresáři programu nebo v knihovně pod názvem \"License\" nebo \"Non_IBM_License\", je-li to možné, nebo poskytnuta ve formě tištěné licenční smlouvy. Před použitím programu se s licenční smlouvou důkladně seznamte. Používáním programu vyjadřujete souhlas s jejími ustanoveními.",
		"groupsAndRoles": "Skupiny a role",
		"metricsMaintenanceTask": "Nová údržba",
		"email": "E-mail",
		"contextual": "Kontextově",
		"resetHome": "Resetovat na výchozí",
		"ltr": "Zleva doprava",
		"credentials": "Pověření",
		"logging_congfig_title": "Protokolování",
		"changePasswordTitle": "Změnit heslo",
		"format": "Formát sestavy",
		"showUnread": "Zobrazit nepřečtené",
		"AILearning_active": "Učení AI je zapnuto:",
		"docsErrorMessage": "Zkuste to znovu. Pokud problém přetrvává, obraťte se na administrátora.",
		"toggleEnabled": "zapnuto",
		"homeSetError": "Při nastavování výchozí domovské stránky došlo k chybě. Zkuste toto zobrazení zavřít a znovu otevřít.",
		"passwordChange": "Změnit heslo",
		"profile": "Profil",
		"pdfRestricted": "PDF (omezené)",
		"drillThrough": "Definice přechodů",
		"homeSet": "Vaše domovská stránka byla úspěšně nastavena.",
		"regionalOptions": "Místní nastavení",
		"myPreferences": "Moje předvolby",
		"defaultHome": "Výchozí",
		"version": "Verze",
		"controller": "Controller",
		"manage": "Spravovat",
		"biDirectionalFeaturesEnabled": "Podpora obousměrných jazyků",
		"newFeaturesErrorTitle": "Odkaz na nové funkce není funkční.",
		"passwordMatch": "Shoda hesla",
		"updateProfileAndsettings": "Aktualizovat profil a nastavení",
		"dashboardConsole": "Pracovní prostor",
		"legacyAppsSlideoutLabel": "Dostupné starší aplikace",
		"logging_config_description": "Protokolování se používá při odstraňování problémů. Ohledně pokynů pro nastavení se obraťte na administrátora.",
		"confirmDeletion": "Potvrďte odstranění",
		"signInButtonText": "Přihlásit se",
		"dataSourceCredentials": "Pověření pro datový server",
		"AILearningConfigurationSlideoutAllyLabel": "Konfigurace učení AI",
		"loadingSettings": "Načítání nastavení",
		"spreadsheetMLRestricted": "Excel (omezené)",
		"manageAILearning": "Učení AI",
		"xlsxDataRestricted": "Data aplikace Excel (omezené)",
		"advanced": "Rozšířené volby",
		"ok": "OK",
		"changeEmail": "Změna",
		"showHints": "Zobrazit pokyny",
		"general": "Obecné",
		"xlsxData": "Data aplikace Excel",
		"newPassword": "Nové heslo",
		"hideAll": "Skrýt vše",
		"confirmPassword": "Potvrdit heslo",
		"AILearning_config_description": "Vylepšete doporučení v produktu povolením získávání informací o vašem způsobu používání produktu Cognos Analytics.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Odkaz na portál podpory (Support Portal) není funkční.",
		"log_level_Warn": "Varování",
		"contentSettings": "Nastavení obsahu",
		"setHomeButton": "Sada",
		"myCapabilities": "Moje funkce",
		"homePage": "Domovská stránka",
		"helpErrorMessage": "Zkuste to znovu. Pokud problém přetrvává, obraťte se na administrátora.",
		"loadingProfile": "Načítání profilu",
		"portal": "Portál",
		"metricsPackage": "Nový balík",
		"myCredentials": "Moje pověření",
		"credentialCreate": "Vytvořit",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Heslo nelze aktualizovat.",
		"showHiddenObjects": "Zobrazit skryté položky",
		"csv": "CSV",
		"docsErrorTitle": "Odkaz na dokumentaci není funkční.",
		"log_level_Error": "Chyba",
		"wrongPassword": "Nelze provést ověření.",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Informace",
		"welcomeBanner": "Pruh uvítání",
		"helpErrorTitle": "Odkaz na nápovědu není funkční.",
		"contentLocale": "Jazyk obsahu",
		"pdf": "PDF",
		"oldPassword": "Původní heslo",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Funkce usnadnění přístupu",
		"manageLogging": "Protokolování",
		"loggingConfigurationSlideoutA11yLabel": "Konfigurace protokolování",
		"communityErrorTitle": "Odkaz na komunitu není funkční.",
		"companionApps": "Doprovodné aplikace",
		"setHomeLabel": "Nastavit domovskou stránku jako (aktuální zobrazení)",
		"metricsExportTask": "Nový export",
		"csvRestricted": "CSV (omezené)",
		"newFeaturesErrorMessage": "Zkuste to znovu. Pokud problém přetrvává, obraťte se na administrátora.",
		"contributor": "Contributor",
		"showAll": "Zobrazit vše",
		"logging_active": "Protokolování je zapnuto:",
		"html": "HTML",
		"profileAndSettings": "Profil a nastavení",
		"baseTextDirection": "Základní směr textu",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Heslo",
		"invalidEmail": "Zadejte platnou e-mailovou adresu",
		"credentialCreateSuccess": "Úspěšně jste vytvořili přihlašovací údaje.",
		"settings": "Nastavení",
		"restrictedFormatSelected": "Možnost spouštění sestav v tomto formátu nemáte k dispozici, máte však přístup k sestavám, které jsou v tomto formátu uloženy.",
		"usageDataDeletionConfirmation": "Odstranění dat o využití resetuje případné učení AI. Opravdu chcete data o využití odstranit?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Zobrazit podrobnosti",
		"deleteUsageData": "Odstranit data o využití:",
		"showPassword": "Zobrazit heslo",
		"AILearning_config_title": "Učení AI",
		"myPreferencesSlideoutLabel": "Profil a nastavení",
		"passWordChangeSuccess": "Úspěšně jste změnili heslo.",
		"logging_level": "Úroveň protokolování:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Zkuste to znovu. Pokud problém přetrvává, obraťte se na administrátora.",
		"cancel": "Storno",
		"shareSetError": "Tuto akci nelze provést dříve, než toto zobrazení zavřete a znovu otevřete.",
		"passwordNotMatch": "Heslo se neshoduje.",
		"xml": "XML",
		"xmlRestricted": "XML (omezené)",
		"openMenu": "Otevřít nabídku",
		"closeMenu": 'Zavřít nabídku'
});